<template>
  <div>
    <h2 v-if="queue ">Clik - {{ queue.name }}</h2>
    <p v-if="queue">{{ queue.description || ""}}</p>
    <br/>
    <vs-tabs>
      <vs-tab label="History">
        <div class="tab" :class="{ greyBorder: resourcesEmpty() === true && loading === 0, hasContent: resourcesEmpty() === false }">
          <div v-if="resourcesEmpty() === true && loading === 0" class="notFound">
            <img src="@/assets/images/pages/guidance-workstation.png">
            <h4>No History</h4>
            <vs-button class="actionButton" :href="'/project/' + id + '/clik/new'">Start this Clik</vs-button>
          </div>
          <!-- Cliks -->
          <vx-card v-if="executions.length >=1 && loading === 0" class="clik overflow-hidden"  :key="'exec_' + exec.guid" v-for="(exec, index) in executions" :id="exec.id">
            <vs-row vs-align="left" class="justify-between flex-no-wrap" >
              <div class="flex items-center justify-start" >
                <div class="dotContainer" >
                  <span class="dot" :class="clikStatus(exec)" ></span>
                </div>
                <span class="flex-1 truncate mr-3 max-w-xs">Job {{Math.abs(index - executions.length)}} </span>
                <span class="lg:inline-block xl:inline-block flex-initial truncate text-sm text-grey hidden max-w-xs">{{dateToLocal(exec.createdAt)}}</span>
              </div> 
              <div class="lg:flex xl:flex flex-1 flex-no-wrap items-center justify-end hidden w-48">
                <vs-button radius color="#b8c2cc" type="flat" size="large" icon="receipt" class="ml-2 float-right" @click="gotoVisualHistory(p_id, id, exec.guid)"></vs-button>
              </div>
            </vs-row>
            <p class="lg:block xl:block truncate text-sm text-grey lg:hidden xl:hidden ml-12 pl-1">{{dateToLocal(exec.createdAt)}}</p>
            <div class="flex justify-around lg:hidden xl:hidden" slot="footer">
              <vs-button class="w-full" color="#b8c2cc" type="flat" size="large" icon="receipt" @click="gotoVisualHistory(p_id, id, exec.guid)">&nbsp;</vs-button>
            </div>
          </vx-card>

        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
export default {
  props: ['id', 'p_id'],
  data () {
    return {
      queue: null,
      executions: []
    }
  },
  methods: {
    loadData () {
      const $this = this
      
      $this.loading++

      $this.$http
        .get(`${process.env.VUE_APP_API_ENDPOINT}/clik/${this.id}/queue`, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        })
        .then(response => {
          $this.queue = response.data
          $this.executions = response.data.executions
          console.log('loadData() -- ', response.data)

          $this.loading--
        })
        .catch(error => {
          $this.loading--
          if (error.response.status === 404) {
            $this.$router.go(-1)
          }
        })
    },
    dateToLocal (d) {
      d = new Date(d)
      return d.toLocaleString()
    },
    gotoVisualHistory (p_id, id, exec_id) {
      this.$router.push({name: 'clik-designer-history', params: { id: p_id, clik_id: id, exec_id }})
    },
    resourcesEmpty () {
      return this.executions.length <= 0
    },
    clikStatus (clik) {
      const status = clik.status
      let output = -1
      switch (status) {
      case 0:
        output = 'success'
        break
      case 1:
        output = 'error'
        break
      case 2:
        output = 'running'
        break
      default:
        output = 'not-run'
      }
      return output
    }
  },
  created () {
    this.loadData()
  }
}
</script>


<style lang="scss">
.clik {
  margin-top: 25px;
  margin-bottom: 25px;
  font-size: 18px;

  > .vs-col {
    width: unset;
    max-width: 100%;
    background-color: black;
  }
  .vx-card__footer {
    padding: 0 !important;
  }
}
.vx-card.bg-danger {
  background-color: rgba(var(--vs-danger),1);
}

.vx-card.bg-danger .vx-card__header, .vx-card.bg-danger h4, .vx-card.bg-danger .vx-card__body {
  color: #fff;
}

.clikName {
  margin: 0;
  position: absolute;
  margin-left: 10px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.flex-1 {
  min-width: 0;
}

// Loaders and Animated Dots
@import "../../assets/css/loader.css";
.clik:not(.settings) .vx-card__body {
  padding: 0.5rem !important;
  padding-left: 1.5rem !important;
}
.vs-tabs--btn {
  font-size: 17px !important;
}
.loading-bg {
  background-color: transparent;
}
.notFound {
  text-align: center;
}
.notFound img {
  width: 20%;
  margin-top: 40px;
}
.tab {
  margin-top: 15px;
  min-height: 200px;
  padding-bottom: 30px;
}
.greyBorder {
  border-radius: 15px;
  border-color: lightgrey;
  border-style: solid;
}
.actionButton {
  margin-top: 15px;
}
#moveResources {
  float: right;
}
.hasContent {
  width: 95%;
  padding: 25px;
}
.dotContainer {
  position: relative;
  width: 24px;
  height: 10px;
  margin-right: 20px;
  display: inline-block;
}
.dot {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 15px;
  height: 15px;
}
.running {
  &:before {
    content: '';
    position: relative;
    display: block;
    width: 300%;
    height: 300%;
    box-sizing: border-box;
    margin-left: -100%;
    margin-top: -100%;
    border-radius: 45px;
    background-color: rgba(var(--vs-success), 0.5);
    animation: pulse-ring 1.25s cubic-bezier(0,0,.58,1) infinite;
  }
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background-color: rgba(var(--vs-success), 1);
    animation: pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite;
  }
}
.success {
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background-color: rgba(var(--vs-success), 1);
  }
}
.error {
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background-color: rgba(var(--vs-danger), 1);
  }
}
.not-run {
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background-color: #b8c2cc;
  }
}
@keyframes pulse-ring {
  0% {
    transform: scale(.33);
  }
  80%, 100% {
    opacity: 0;
  }
}
@keyframes pulse-dot {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.33);
  }
  100% {
    transform: scale(1);
  }
}
</style>